import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteReviewReply } from "../../api/bReviewsApi";

export function useDeleteReviewReply() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => deleteReviewReply(data),
    onSuccess: () => {
      // Invalidate reviews list to refetch with updated data
      queryClient.invalidateQueries({ queryKey: ["reviews-list"] });
      queryClient.invalidateQueries({ queryKey: ["dashboard-stats"] });
    },
  });
}
